export class GlobalSettings  {
    static InsightsApiUrl  = "http://tab.theappbuilder.local:2228/admin/Analytics/GetAnalytics"
    static DefaultLogo = "images/logos/logo.svg"; 
    static CmsPath = "http://tab.theappbuilder.local:2228";
}